import {
    CREATE_PAYMENT_LINK_SUCCESS,
    CREATE_PAYMENT_LINK_ERROR,
    GET_ALL_PAYMENT_LINKS_SUCCESS,
    GET_ALL_PAYMENT_LINKS_ERROR,
    GET_PAYMENT_LINK_BY_ID_SUCCESS,
    GET_PAYMENT_LINK_BY_ID_ERROR,
    VERIFY_PAYMENT_LINK_STATUS_SUCCESS,
    VERIFY_PAYMENT_LINK_STATUS_ERROR,
    PAYMENT_LINK_LOADING,
    CLEAR_PAYMENT_LINK
} from '../actions/types';

const initialState = {
    paymentLink: null,
    paymentLinks: [],
    loading: false,
    error: null,
    pagination: {
        page: 1,
        count: 10,
        total: 0,
        pages: 0
    }
};

export default function paymentLink(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case PAYMENT_LINK_LOADING:
            return {
                ...state,
                loading: true,
                error: null
            };

        case CREATE_PAYMENT_LINK_SUCCESS:
            return {
                ...state,
                paymentLink: payload,
                loading: false,
                error: null
            };

        case CREATE_PAYMENT_LINK_ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case GET_ALL_PAYMENT_LINKS_SUCCESS:
            return {
                ...state,
                paymentLinks: payload.data || [],
                pagination: {
                    page: payload.page || 1,
                    count: payload.count || 10,
                    total: payload.total || 0,
                    pages: payload.pages || 0
                },
                loading: false,
                error: null
            };

        case GET_ALL_PAYMENT_LINKS_ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case GET_PAYMENT_LINK_BY_ID_SUCCESS:
            return {
                ...state,
                paymentLink: payload,
                loading: false,
                error: null
            };

        case GET_PAYMENT_LINK_BY_ID_ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case VERIFY_PAYMENT_LINK_STATUS_SUCCESS:
            return {
                ...state,
                paymentLink: payload,
                loading: false,
                error: null
            };

        case VERIFY_PAYMENT_LINK_STATUS_ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case CLEAR_PAYMENT_LINK:
            return {
                ...state,
                paymentLink: null,
                error: null
            };

        default:
            return state;
    }
}

